export const countWrapperCss = {
  padding: "13px 16px",
};
